import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ReportForm } from '../../components/ReportForm/ReportForm';
import {
  IReportMessagePopupParams,
  useReportMessagePopupPresenter,
} from './ReportMessagePopup.presenter';

export const ReportMessagePopup: FC<ICommonPopupsProps<IReportMessagePopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useReportMessagePopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        title={t('common_report')}
        isOpened
        onClose={presenter.onClose}
      >
        <ReportForm
          title={t('content_moderation_message')}
          onSubmit={presenter.onSubmit}
        />
      </Popup>
    );
  }
);
